import React from 'react';
import { observer } from 'mobx-react';
import classes from './Summary.module.scss';

export const Summary = observer(() => {
  return <div className={classes.root}>Summary</div>;
});
